module.exports = __webpack_public_path__ + "img/big-room2.2b738c84.png";